export default "__VITE_ASSET__B8h2oMTB__"